<template>
  <NoData v-if="!store.reportsCount" />
  <template v-else>
    <ul class="reports-list">
      <li v-for="report in store.reports" :key="report._id">
        <ReportCard v-focus :report="report" />
      </li>
    </ul>

    <!-- Pagination -->
    <PaginationElement
      v-if="store.reportsCount"
      :key="`${store.reportsCount}${store.selectedFilters.from}${store.selectedFilters.size}`"
      :total-items="store.reportsCount"
      :current-page="store.selectedFilters.from"
      :items-limit="store.selectedFilters.size"
      @change-current-page="changeCurrentPage"
    />
  </template>
</template>

<script setup>
import ReportCard from "@follaw-fr/components/legi-reports/molecules/ReportCard.vue";
import NoData from "@follaw-fr/components/reusable/atoms/NoData.vue";
import PaginationElement from "@follaw-fr/components/reusable/atoms/PaginationElement.vue";
import { useLegiReportStore } from "@follaw-fr/stores/legi-reports";
const store = useLegiReportStore();

const changeCurrentPage = (from) => {
  store.selectedFilters.from = from;
  store.fetchLegiReportsList();
};
</script>

<style scoped lang="scss">
.reports-list {
  list-style: none;
  margin: 0;
  padding: 0;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 10px;
}
</style>
